/**
 * Read Today Artifact Node — single-item read by today_in_tz(user_tz).
 */

import { memo } from 'react';
import { type NodeProps } from '@xyflow/react';
import { BaseNode } from './BaseNode';
import type { NodeData } from '@/types/imageWorkflow';

const ReadTodayArtifactNodeComponent = ({ id, data, selected }: NodeProps) => {
  const nodeData = data as NodeData;
  const artifactType = nodeData.artifact_type ?? 'push_content';
  const targetField = nodeData.target_date_field ?? 'today_in_user_tz';

  return (
    <BaseNode id={id} data={nodeData} type="read_today_artifact" selected={selected}>
      <div className="space-y-1.5">
        <div className="text-xs text-gray-500">
          type: <span className="text-gray-700 font-mono">{String(artifactType)}</span>
        </div>
        <div className="text-xs text-gray-500">
          date: <span className="text-gray-700 font-mono">{String(targetField)}</span>
        </div>
      </div>
    </BaseNode>
  );
};

export const ReadTodayArtifactNode = memo(ReadTodayArtifactNodeComponent);
export default ReadTodayArtifactNode;
